<div class="panel space-y-5">
  <h5 class="mb-4 text-lg font-semibold">
    {{ "contract.db_import" | translate }}
  </h5>
  <p>
    {{ "contract.db_import_info" | translate }}
  </p>
  <button class="btn btn-secondary" (click)="openImportModal()">
    {{ "contract.import" | translate }}
  </button>
</div>

<ng-template #importModalTemplate>
  <div class="flex flex-col p-4">
    <div class="!pb-5 text-xl">{{ "contract.db_import" | translate }}</div>
    <div class="relative z-[1]">
      <div
        class="absolute top-[30px] -z-[1] m-auto h-1 w-[15%] bg-primary transition-[width] ltr:left-0 rtl:right-0"
        [ngStyle]="{
          width: activeTab === 1 ? '23%' : '100%',
        }"
      ></div>
      <ul [ngClass]="'grid-cols-2'" class="mb-5 grid">
        <li class="mx-auto flex flex-col items-center justify-center">
          <a
            href="javascript:;"
            class="flex h-16 w-16 items-center justify-center rounded-full border-[3px] border-[#f3f2ee] bg-white dark:border-[#1b2e4b] dark:bg-[#253b5c]"
            [ngClass]="{ '!border-primary !bg-primary text-white': activeTab === 1 }"
          >
            <icon-txt-file></icon-txt-file>
          </a>
          <span class="mt-2 block text-center" [ngClass]="{ 'text-primary': activeTab === 1 }">{{ "contract.db_import" | translate }}</span>
        </li>
        <li class="mx-auto flex flex-col items-center justify-center">
          <a
            href="javascript:;"
            class="flex h-16 w-16 items-center justify-center rounded-full border-[3px] border-[#f3f2ee] bg-white dark:border-[#1b2e4b] dark:bg-[#253b5c]"
            [ngClass]="{ '!border-primary !bg-primary text-white': activeTab === 2 }"
          >
            <icon-user></icon-user>
          </a>
          <span class="mt-2 block text-center" [ngClass]="{ 'text-primary': activeTab === 2 }">{{ "contract.migrate_users" | translate }}</span>
        </li>
      </ul>
    </div>

    <div *ngIf="activeTab === 1" class="mt-8">
      <div class="flex items-center gap-5 mb-5">
        <div>
          <button type="button" class="btn btn-primary flex transform items-center gap-2 rounded-lg p-2 text-white shadow-md transition" (click)="triggerFileInput()">
            <icon-upload></icon-upload>
            <span>{{ "add_file" | translate }}</span>
          </button>
          <ng-content></ng-content>
          <input type="file" #fileInput class="hidden" (change)="onFileSelected($event)" />
        </div>
        <p *ngIf="file">{{ file.name }}</p>
      </div>

      <h1 class="text-danger text-xl mb-2">{{ "contract.warning" | translate }}</h1>
      <p class="mb-5">{{ "contract.warning_info" | translate }}</p>
    </div>

    <div *ngIf="activeTab === 2" class="mt-8">
      <div *ngIf="isLoadingUsers" class="screen_loader animate__animated absolute inset-0 z-[35] grid place-content-center bg-[#fafafa] opacity-65 dark:bg-[#060818]">
        <img class="ml-[5px] h-auto w-20 flex-none" src="/assets/images/loader.svg" alt="" />
      </div>

      <p class="my-5">{{ "contract.migrate_info" | translate }}</p>

      <div *ngFor="let user of users" class="flex items-center space-x-2">
        <span class="flex items-center gap-2">
          <input type="checkbox" [checked]="selectedEmails.includes(user)" class="form-checkbox" (change)="toggleEmail(user, $event)" />
          {{ user }}
        </span>
      </div>

      <h1 class="text-danger text-xl mb-2 mt-8">{{ "contract.warning" | translate }}</h1>
      <p class="mb-5">{{ "contract.migrate_warning" | translate }}</p>
    </div>

    <div class="flex justify-end">
      <button *ngIf="activeTab == 1" class="btn btn-primary" [disabled]="loading" (click)="handleImport()">
        <ng-container *ngIf="loading; else alternateTranslation">
          <span class="inline-block h-3 w-3 animate-ping rounded-full bg-white ltr:mr-4 rtl:ml-4"></span>
          {{ "loading" | translate }}
        </ng-container>
        <ng-template #alternateTranslation>
          <span>{{ "contract.import" | translate }}</span>
        </ng-template>
      </button>

      <button *ngIf="activeTab == 2" class="btn btn-primary" [disabled]="loading" (click)="handleMigrate()">
        <ng-container *ngIf="loading; else alternateTranslation">
          <span class="inline-block h-3 w-3 animate-ping rounded-full bg-white ltr:mr-4 rtl:ml-4"></span>
          {{ "loading" | translate }}
        </ng-container>
        <ng-template #alternateTranslation>
          <span>{{ "contract.migrate" | translate }}</span>
        </ng-template>
      </button>
    </div>
  </div>
</ng-template>
